import { createApp } from 'vue';
import store from 'shared/store';
import GlobalSearchPopup from 'shared/components/globalSearch/globalSearchPopup.vue';
import GlobalNavigation from "./GlobalNavigation.vue";
import "@coloplast/design-system/dist/components/header/ds-header.css";

const globalNavigationMountElem = document.getElementById('global-navigation-mount');
if (globalNavigationMountElem) {
	const app = createApp({
		name: 'GlobalNavigationApp',
	});
	app.component('global-navigation', GlobalNavigation);
	app.component('global-search-popup', GlobalSearchPopup);
	app.use(store);
	app.mount(globalNavigationMountElem);
}